
<div class="">
    <button mat-flat-button class="new-sorting-btn start-sm-0" [matMenuTriggerFor]="dateList"
      [ngClass]="{'active': isNameApply}" (click)="!isNameApply && nameValue('15'); isNameApply && prevData()">
      <div class="d-flex align-items-center">
        <div class=" " (click)="isNameApply && removeDateFilter()">
          <img src="../../../../assets/images/plus-circle.svg" alt="">
        </div>

        <span class="ms-2">Age <span *ngIf="isNameApply">| </span></span>

        <h6 class="m-0 ms-1" *ngIf="isNameApply">> {{selectedView}} days</h6>
      </div>
    </button>

    <div>
      <mat-menu #dateList="matMenu" class="new-mat-menu mt-1 dateFilter" xPosition="before">
        <div class="p-3" (click)="stopPropagation($event)" style="box-sizing: border-box; width: 100%;">
          <p class="mb-2" style="font-size: 13px; font-weight: 700; color: #1e293b; font-family: 'Gilroy', sans-serif;">Filter by Age</p>
          
          <app-select
            size="compact"
            [options]="ageOptions"
            [(ngModel)]="selectedOption"
            (selectionChange)="nameValue($event)"
            placeholder="Select"
            class="w-100 mb-3"
          ></app-select>

          <div class="mt-3">
            <app-primary-button
              label="APPLY"
              size="medium"
              [fullWidth]="true"
              [disabled]="!selectedOption"
              (btnClick)="applyDate(selectedOption)"
            ></app-primary-button>
          </div>
        </div>
      </mat-menu>
    </div>

  </div>